import * as React from 'react';
import styled from 'styled-components';
import {
  Container as LastTransactionsContainer,
  Header,
  Title,
  ButtonShowAll,
} from './LastTransactions';
import ItemCard, {ItemCardType} from './ItemCard';
import {CourseObject, getCourses} from 'api/course';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/is-error';
import {navigateTo} from "helpers/navigate-to";
import {useRoute} from 'react-router5';
import moment from 'moment';
import {getImageByPreview} from 'api/library';
import {router} from 'containers/AppContainer';

const Container = styled(LastTransactionsContainer)`
  max-width: none;
  border: none;
  background-color: transparent;
  
  ${Header} {
    padding: 0;
    margin-bottom: 14px;
    background-color: transparent;
  }
`;

export const Content = styled.div`
  display: grid;
  gap: 10px;
`;

/**
 * The function render last courses block
 * @constructor
 */
export default function LastCourses() {
  const {route} = useRoute();
  const [
    isLoaded,
    setLoaded,
  ] = React.useState<boolean>(false);

  const [
    courses,
    setCourses,
  ] = React.useState<CourseObject[]>([]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      fetchCourses();
    }, 600);
    return () => clearTimeout(timeout);
  }, [route.params.search]);

  /**
   * Fetch courses.
   */
  function fetchCourses(): void {
    setLoaded(false);

    getCourses({
      my: '1',
      title: route.params.search,
    }).then((response) => {
      validateResponse(response);

      if (response && !isError(response)) {
        setCourses(response);
        setLoaded(true);
      }
    });
  }

  /**
   * The function render content
   * @constructor
   */
  function renderContent() {
    const result: CourseObject[] = [];

    const course1 = courses.length && courses[courses.length - 1];
    const course2 = courses.length && courses[courses.length - 2];

    course1 && result.push(course1);
    course2 && result.push(course2);

    return result.map(renderItem);
  }

  /**
   * The function render content item
   * @param {CourseObject} course
   * @constructor
   */
  function renderItem(course: CourseObject) {
    const image = getImageByPreview(course.preview);
    return (
      <ItemCard
        key={course.id}
        type={ItemCardType.Course}
        title={course.title}
        info={'Создан ' + moment(course.createdAt).format('DD.MM.YYYY')}
        imgSrc={image}
        onBtnClick={() => router.navigate('courses.course', {id: course.id})}
      />
    );
  }

  /**
   * The navigation handler function
   * @constructor
   */
  function navigateHandler() {
    navigateTo('courses')
  }

  return courses.length
    ? (
        <Container>
          <Header>
            <Title>Последние созданные курсы</Title>
            <ButtonShowAll onClick={navigateHandler}>Все</ButtonShowAll>
          </Header>
          <Content>
            {renderContent()}
          </Content>
        </Container>
      )
    : null;
}
